import { useEffect } from "react";

const TermsOfUse = () => {
  const termsOfUseLink = "https://www.orie.ai/terms-of-use";

  useEffect(() => {
    try {
      window.location.href = termsOfUseLink;
    } catch (error) {
      console.error("Redirection failed:", error);
    }
  }, []);

  return null;
};

export default TermsOfUse;
